/* eslint-disable react-hooks/exhaustive-deps */
import api from "@services/api";
import { URLS } from "@services/urls";
import { useCallback } from "react";
import { useSession } from "@hooks/useSession";
import useApiErrorHandler from "@hooks/useApiErrorHandler";
import { useTranslation } from "react-i18next";

// Helper functions for token management
const getToken = () => localStorage.getItem("token");

// Helper function to create headers
const createHeaders = (lang) => {
  const token = getToken();
  return {
    "Content-Type": "application/json",
    "Accept-Language": lang,
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
};

// Authentication service hook
export const useAuthService = () => {
  const { setToken, setSession } = useSession();
  const { handleApiError } = useApiErrorHandler();
  const { i18n } = useTranslation();

  // Function to handle user sign-in
  const signin = async (data, lang = i18n.language) => {
    try {
      const response = await api.post(
        URLS.auth.LOGIN_URL,
        JSON.stringify(data),
        { headers: createHeaders(lang) }
      );
      const { token } = response.data;

      setToken(token);
      setSession(response.data); // Keep for compatibility
      return response;
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  };

  // Function to handle user sign-up
  const signup = async (data, lang = i18n.language) => {
    try {
      const response = await api.post(
        URLS.auth.REGISTER_URL,
        JSON.stringify(data),
        { headers: createHeaders(lang) }
      );
      return response;
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  };

  return {
    signin: useCallback(signin, [i18n.language]),
    signup: useCallback(signup, [i18n.language]),
  };
};
